(function (window, document) {
  'use strict';

  /*
   * "How should we print your image?" on custom-upload products.
   *
   * After Upload-Lift stores the customer's cropped upload, this measures its
   * print resolution at the ordered size. For a small or low-DPI image (the
   * core's needsChoice), or one it cannot measure, it shows a print-size
   * preview and asks
   * "Enhance my image" or "Keep exactly as uploaded", blocks Add to cart and
   * hides accelerated checkout until the customer answers, and writes the
   * answer as a VISIBLE line-item property: the customer's receipt in the
   * cart, at checkout and in the order email. The server enforces it:
   * keep = no AI engine, slow lane or bleed fix, and the supplier workbook
   * says so.
   */

  var core = window.EpicImageEnhancementCore;
  if (!core) {
    if (window.console && typeof window.console.error === 'function') {
      window.console.error('[Epic image enhancement] Core module did not load.');
    }
    return;
  }

  var bootstrap = window.__epicImageEnhancementBootstrap = window.__epicImageEnhancementBootstrap || {};
  bootstrap.events = Array.isArray(bootstrap.events) ? bootstrap.events : [];
  var PANEL_SELECTOR = '[data-epic-image-enhancement]';
  var EXPRESS_SELECTOR = '.shopify-payment-button, [data-shopify="payment-button"], [data-testid="Checkout-button"]';

  function panelConfig(panel) {
    if (panel.__epicConfig) return panel.__epicConfig;
    var config = { productId: '', variants: {}, firstVariantId: '' };
    var script = panel.querySelector('script[type="application/json"][data-epic-ie-config]');
    if (script) {
      try {
        var parsed = JSON.parse(script.textContent || '{}');
        config.productId = String(parsed.productId || '');
        config.variants = parsed.variants && typeof parsed.variants === 'object' ? parsed.variants : {};
        config.firstVariantId = String(parsed.firstVariantId || '');
      } catch (error) {
        // An unreadable config leaves dims unknown, which asks the question.
      }
    }
    panel.__epicConfig = config;
    return config;
  }

  function panelState(panel) {
    if (!panel.__epicState) {
      panel.__epicState = {
        upload: null, dims: null, dpi: null, needed: false, choice: '', pixelArt: false, measuring: false, token: 0
      };
    }
    return panel.__epicState;
  }

  function allPanels() {
    return Array.prototype.slice.call(document.querySelectorAll(PANEL_SELECTOR));
  }

  function panelForTarget(target) {
    var panels = allPanels();
    var root = target && target.closest ? target.closest('[data-upload-lift]') : null;
    var productId = root ? root.getAttribute('data-upload-lift') : '';
    for (var index = 0; index < panels.length; index += 1) {
      if (productId && panelConfig(panels[index]).productId === String(productId)) return panels[index];
    }
    return panels.length === 1 ? panels[0] : null;
  }

  function isPurchaseForm(form) {
    return Boolean(form && /\/cart\/add(?:\.js)?(?:\?|$)/.test(form.getAttribute('action') || form.action || '') &&
      !form.classList.contains('js-instalments-form'));
  }

  // Every purchase form on the page: Symmetry renders a sticky Add to cart
  // form beside the main one, so the answer rides on all of them and any of
  // them is held while the answer is missing.
  function purchaseForms() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var result = [];
    for (var index = 0; index < forms.length; index += 1) {
      if (isPurchaseForm(forms[index])) result.push(forms[index]);
    }
    return result;
  }

  function formForPanel(panel) {
    // Upload-Lift links its own hidden inputs to the real product form.
    var uploadInput = document.querySelector('input[name="properties[uploaded_image]"]');
    if (uploadInput && isPurchaseForm(uploadInput.form)) return uploadInput.form;
    var scope = panel.closest('.product-form, .product__info-container, [data-product-id]') || document;
    var forms = scope.querySelectorAll('form[action*="/cart/add"]');
    var purchase = [];
    for (var index = 0; index < forms.length; index += 1) {
      if (isPurchaseForm(forms[index])) purchase.push(forms[index]);
    }
    if (purchase.length === 1) return purchase[0];
    if (scope !== document) {
      forms = document.querySelectorAll('form[action*="/cart/add"]');
      purchase = [];
      for (var other = 0; other < forms.length; other += 1) {
        if (isPurchaseForm(forms[other])) purchase.push(forms[other]);
      }
      if (purchase.length === 1) return purchase[0];
    }
    return null;
  }

  function currentDims(panel) {
    var config = panelConfig(panel);
    var form = formForPanel(panel);
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var variantId = idInput && idInput.value ? String(idInput.value) : config.firstVariantId;
    return core.skuDimensions(config.variants[variantId] || config.variants[config.firstVariantId] || '');
  }

  function ensureInput(form, name) {
    var selector = 'input[data-epic-ie-property="' + name + '"]';
    var input = form.querySelector(selector);
    if (input) return input;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + name + ']';
    input.setAttribute('data-epic-ie-property', name);
    input.disabled = true;
    form.appendChild(input);
    return input;
  }

  function syncProperties(panel) {
    var state = panelState(panel);
    var answered = Boolean(state.upload && state.needed && state.choice);
    var resolution = state.upload
      ? core.resolutionRecord(state.upload.width, state.upload.height, state.dims, state.dpi)
      : '';
    var forms = purchaseForms();
    for (var index = 0; index < forms.length; index += 1) {
      var choiceInput = ensureInput(forms[index], core.PROPERTY_NAME);
      choiceInput.value = core.propertyValue(state.choice);
      choiceInput.disabled = !answered;
      var record = ensureInput(forms[index], core.RESOLUTION_PROPERTY);
      record.value = resolution;
      record.disabled = !answered;
    }
  }

  function syncExpressCheckout(panel) {
    var state = panelState(panel);
    var blocked = Boolean(state.upload && state.needed && !state.choice);
    var form = formForPanel(panel);
    var scope = (form && form.closest('.product-form, .product__info-container, [data-product-id]')) ||
      panel.closest('.product-form, .product__info-container, [data-product-id]') || form;
    if (!scope) return;
    var buttons = scope.querySelectorAll(EXPRESS_SELECTOR);
    for (var index = 0; index < buttons.length; index += 1) {
      var button = buttons[index];
      if (blocked) {
        if (!button.hasAttribute('data-epic-ie-hidden')) {
          button.setAttribute('data-epic-ie-hidden', button.hidden ? 'was-hidden' : 'true');
          button.hidden = true;
        }
      } else if (button.getAttribute('data-epic-ie-hidden') === 'true') {
        button.hidden = false;
        button.removeAttribute('data-epic-ie-hidden');
      } else if (button.hasAttribute('data-epic-ie-hidden')) {
        button.removeAttribute('data-epic-ie-hidden');
      }
    }
  }

  function setText(panel, selector, text) {
    var element = panel.querySelector(selector);
    if (element) element.textContent = text;
  }

  function renderPreview(panel) {
    var state = panelState(panel);
    var preview = panel.querySelector('[data-epic-ie-preview]');
    if (!preview || !state.upload) return;
    // About 96 CSS pixels to the inch on a screen: show a window of the image
    // at the size one source pixel will cover on the mat.
    var scale = state.dpi ? Math.max(1, Math.min(24, 96 / state.dpi)) : 3;
    var width = Math.max(1, Math.round(state.upload.width * scale));
    var height = Math.max(1, Math.round(state.upload.height * scale));
    preview.style.backgroundImage = 'url("' + String(state.upload.url).replace(/"/g, '%22') + '")';
    preview.style.backgroundSize = width + 'px ' + height + 'px';
    preview.style.backgroundPosition = 'center';
    preview.style.imageRendering = state.choice === 'keep' && state.pixelArt ? 'pixelated' : 'auto';
  }

  function render(panel) {
    var state = panelState(panel);
    var show = Boolean(state.upload && state.needed && !state.measuring);
    panel.hidden = !show;
    if (show) {
      var sizeLabel = state.dims ? (state.dims.widthMm / 10) + ' × ' + (state.dims.heightMm / 10) + ' cm' : 'this size';
      var measured = state.upload.width > 0 && state.upload.height > 0;
      setText(
        panel,
        '[data-epic-ie-detail]',
        measured && state.dpi
          ? 'Your image is ' + Math.round(state.upload.width) + ' × ' + Math.round(state.upload.height) +
            ' pixels, about ' + Math.round(state.dpi) + (Math.round(state.dpi) === 1 ? ' pixel' : ' pixels') +
            ' per inch on ' + sizeLabel +
            '. It will look soft or blocky up close.'
          : 'We could not measure your image. If it is small, it may look soft or blocky on ' + sizeLabel + '.'
      );
      var radios = panel.querySelectorAll('input[type="radio"][data-epic-ie-choice]');
      for (var index = 0; index < radios.length; index += 1) {
        radios[index].checked = radios[index].value === state.choice;
      }
      var hint = panel.querySelector('[data-epic-ie-pixel-hint]');
      if (hint) hint.hidden = !state.pixelArt;
      renderPreview(panel);
    }
    if (!show || state.choice) {
      var error = panel.querySelector('[data-epic-ie-error]');
      if (error) error.hidden = true;
      panel.classList.remove('epic-ie--blocked');
    }
    syncProperties(panel);
    syncExpressCheckout(panel);
  }

  function evaluate(panel) {
    var state = panelState(panel);
    if (!state.upload) {
      state.needed = false;
      render(panel);
      return;
    }
    state.dims = currentDims(panel);
    state.dpi = core.printDpi(state.upload.width, state.upload.height, state.dims);
    // Until the size is known the answer may be needed: Add to cart waits.
    state.needed = state.measuring ||
      core.needsChoice(state.dpi, Math.max(state.upload.width, state.upload.height));
    render(panel);
  }

  function detectPixelArt(panel, token) {
    var state = panelState(panel);
    if (!state.upload || !(state.upload.width > 0) ||
      Math.max(state.upload.width, state.upload.height) > core.PIXEL_ART_MAX_LONG_EDGE) return;
    var image = new window.Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () {
      if (panelState(panel).token !== token) return;
      try {
        var canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0);
        var pixels = context.getImageData(0, 0, canvas.width, canvas.height);
        state.pixelArt = core.looksLikePixelArt(pixels.data, canvas.width, canvas.height);
        render(panel);
      } catch (error) {
        // No CORS read: no hint. The question still shows.
      }
    };
    image.src = core.corsUrl(state.upload.url);
  }

  function measure(panel, token) {
    var state = panelState(panel);
    if (state.upload.width > 0 && state.upload.height > 0) {
      evaluate(panel);
      detectPixelArt(panel, token);
      return;
    }
    // Dimensions from the image itself; no CORS is needed to read them.
    var image = new window.Image();
    image.onload = function () {
      if (panelState(panel).token !== token) return;
      state.measuring = false;
      state.upload.width = image.naturalWidth;
      state.upload.height = image.naturalHeight;
      evaluate(panel);
      detectPixelArt(panel, token);
    };
    image.onerror = function () {
      if (panelState(panel).token !== token) return;
      state.measuring = false;
      evaluate(panel);
    };
    state.measuring = true;
    evaluate(panel);
    image.src = state.upload.url;
  }

  // Upload-Lift's derived files. The main cropped upload (the one it writes
  // to properties[uploaded_image]) arrives with meta.variant "original",
  // so only these named variants are children to ignore.
  var CHILD_VARIANTS = { thumbnail: true, _original: true, _text: true, convert: true };

  function isMainFile(detail) {
    if (!detail || !detail.url || detail.parent) return false;
    var variant = detail.meta && detail.meta.variant;
    return !(variant && CHILD_VARIANTS[variant]);
  }

  function placePanel(panel, target) {
    // After Upload-Lift's outer root, so its own re-renders never remove us.
    var root = target && target.closest
      ? (target.closest('[data-upload-lift]') || target.closest('[data-upload-field]'))
      : null;
    if (!root || !root.parentNode || panel.contains(root) || root.nextSibling === panel) return;
    root.parentNode.insertBefore(panel, root.nextSibling);
  }

  function handleAdded(target, detail) {
    if (!isMainFile(detail)) return;
    var panel = panelForTarget(target);
    if (!panel) return;
    placePanel(panel, target);
    var state = panelState(panel);
    var meta = detail.meta || {};
    if (state.upload && state.upload.url === String(detail.url)) {
      // The same file seen twice (adopted from the form, then its event):
      // keep the customer's answer, only fill in a size we lacked.
      if (!(state.upload.width > 0) && Number(meta.width) > 0 && Number(meta.height) > 0) {
        state.upload.width = Number(meta.width);
        state.upload.height = Number(meta.height);
        evaluate(panel);
      }
      return;
    }
    state.token += 1;
    state.upload = {
      url: String(detail.url),
      width: Number(meta.width) || 0,
      height: Number(meta.height) || 0
    };
    state.choice = '';
    state.pixelArt = false;
    measure(panel, state.token);
  }

  function handleRemoved(target, detail) {
    if (!isMainFile(detail)) return;
    var panel = panelForTarget(target);
    if (!panel) return;
    var state = panelState(panel);
    if (state.upload && state.upload.url !== String(detail.url)) return;
    state.token += 1;
    state.upload = null;
    state.choice = '';
    state.pixelArt = false;
    state.measuring = false;
    evaluate(panel);
  }

  function handleEvent(record) {
    if (record.type === 'upload:added') handleAdded(record.target, record.detail);
    else if (record.type === 'upload:removed') handleRemoved(record.target, record.detail);
  }

  function blockIfUnanswered(event, form) {
    if (!isPurchaseForm(form)) return;
    var panels = allPanels();
    for (var index = 0; index < panels.length; index += 1) {
      var panel = panels[index];
      var state = panelState(panel);
      if (!state.upload) continue;
      evaluate(panel); // the variant (size) may have changed since upload
      if (!state.needed || state.choice) continue;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      var error = panel.querySelector('[data-epic-ie-error]');
      if (error) {
        error.textContent = state.measuring
          ? 'Still checking your image. Try again in a moment.'
          : 'Choose how we should print your image before adding it to cart.';
        error.hidden = false;
      }
      if (state.measuring) {
        panel.hidden = false;
      }
      panel.classList.add('epic-ie--blocked');
      panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = panel.querySelector('input[type="radio"][data-epic-ie-choice]');
      if (first) window.setTimeout(function () { first.focus(); }, 250);
      return;
    }
  }

  function installListeners() {
    if (bootstrap.listenersInstalled) return;
    bootstrap.listenersInstalled = true;
    // The inline bootstrap queued any events that fired before this loaded.
    bootstrap.handle = handleEvent;
    var queued = bootstrap.events;
    bootstrap.events = [];
    for (var index = 0; index < queued.length; index += 1) handleEvent(queued[index]);
    if (!bootstrap.captureInstalled) {
      bootstrap.captureInstalled = true;
      ['upload:added', 'upload:removed'].forEach(function (type) {
        window.addEventListener(type, function (event) {
          handleEvent({ type: type, target: event.target, detail: event.detail });
        }, true);
      });
    }

    document.addEventListener('submit', function (event) {
      blockIfUnanswered(event, event.target);
    }, true);
    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest &&
        event.target.closest('button[type="submit"], input[type="submit"], button:not([type])');
      if (button && button.form) blockIfUnanswered(event, button.form);
    }, true);
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('input[type="radio"][data-epic-ie-choice]')) {
        var panel = target.closest(PANEL_SELECTOR);
        if (!panel) return;
        panelState(panel).choice = target.value === 'keep' ? 'keep' : 'enhance';
        render(panel);
        return;
      }
      // A size (variant) change re-measures against the new mat.
      var panels = allPanels();
      for (var index = 0; index < panels.length; index += 1) {
        if (panelState(panels[index]).upload) evaluate(panels[index]);
      }
    }, true);
  }

  // Upload-Lift can restore a previous upload before this file loads, and
  // its upload:added may then fire before any listener exists. It always
  // leaves a properties[uploaded_image] input in the form, so pick that up.
  function adoptExistingUploads() {
    var inputs = document.querySelectorAll('input[name="properties[uploaded_image]"]');
    for (var index = 0; index < inputs.length; index += 1) {
      var input = inputs[index];
      var url = String(input.value || '').trim();
      if (!/^https:\/\//.test(url)) continue;
      var panel = panelForTarget(input);
      if (!panel || panelState(panel).upload) continue;
      handleAdded(input, { url: url, meta: {} });
    }
  }

  installListeners();
  var panels = allPanels();
  for (var index = 0; index < panels.length; index += 1) render(panels[index]);
  adoptExistingUploads();
  window.addEventListener('load', adoptExistingUploads);
})(window, document);
